module.exports = __webpack_public_path__ + "img/reklamefriqrs01.ea3bd18d.jpeg";